import useDi from '../useDi'

import Token from '@/di/di.token'

export default function useSessionGroupService() {
  const { container } = useDi()
  const service = container.get(Token.SESSION_GROUP_SERVICE)
  return { service }
}
